<template>
    <div>
        <Navbar :alt="$route.path == '/'"></Navbar>
        <div class="wrapper">
            <router-view></router-view>
        </div>
        <footer class="footer" data-background-color="black">
            <div class="container">
                <!-- <nav>
                    <ul>
                        <li>
                            <a href="https://www.creative-tim.com">
                                Creative Tim
                            </a>
                        </li>
                        <li>
                            <a href="http://presentation.creative-tim.com">
                                About Us
                            </a>
                        </li>
                        <li>
                            <a href="http://blog.creative-tim.com">
                                Blog
                            </a>
                        </li>
                        <li>
                            <a href="https://github.com/creativetimofficial/now-ui-kit/blob/master/LICENSE.md">
                                MIT License
                            </a>
                        </li>
                    </ul>
                </nav> -->
                <div class="copyright">
                    ©2018
                    <a href="https://bplasticsolutions.com">bplasticsolutions.com</a>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
import Navbar from './components/Navbar'
export default {
    components: { Navbar },
}
</script>

<style lang="scss">
@import './assets/vendor/sass/now-ui-kit';
</style>



// WEBPACK FOOTER //
// src/App.vue